module.exports = __webpack_public_path__ + "static/carl-headshot-clipped-301083fd5ca946dc95f2a161d1624bbe.png";